<script>

  export let reverse;
  export let color;

  const scaleX = reverse ? -1 : 1;
  const translateX = reverse ? -108 : 0;

</script>

<style>
@media screen and (max-width: 768px) {
  svg {
    width: 80px;
  }
}
</style>

<svg width="108" height="108" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g>
    <circle cx="54" cy="51" r="38" fill="{color}"/>
  </g>
  <g transform='scale({scaleX} 1) translate({translateX} 0)'>
    <path d="M81.0684 51.0227L65.0456 51.0227L65.0456 34.9999L81.0684 51.0227Z" fill="white" style="fill: white;"/>
    <path d="M49.0228 67.0457L33 67.0457L49.0228 51.0228L49.0228 67.0457Z" fill="white" style="fill: white;"/>
    <path d="M49.0228 51.0227L33 34.9999L49.0228 34.9999L49.0228 51.0227Z" fill="white" style="fill: white;"/>
    <path d="M65.0456 67.0454L65.0456 51.0226L81.0684 51.0226L65.0456 67.0454Z" fill="white" style="fill: white;"/>
    <rect x="65.0456" y="67.0457" width="16.0228" height="16.0228" transform="rotate(-180 65.0456 67.0457)" fill="white" style="fill: white;"/>
    <rect x="65.0456" y="51.0227" width="16.0228" height="16.0228" transform="rotate(-180 65.0456 51.0227)" fill="white" style="fill: white;"/>
  </g>
</svg>
